import Icon from '@/common/components/Icon';
import { FlexCell } from '../components/refundTable/RefundTable.styles';
import moment from 'moment';
import { REFUND_STATUSES, REFUND_REASONS } from '@/common/constants/refunds';

const TO_DO_STATUS = 'TO_DO'

export const getRows = (refunds, setSelectedRefund, handleDownloadPdf, loadingFiles) =>
	refunds.map((refund, index) => {
		return (
			<tr
				style={{
					fontWeight: 'bold',
				}}
				key={refund._id}
			>
				<td>{index + 1}</td>
				<td>{refund.market.name}</td>
				<td>{refund.consultant.name} {refund.consultant.surname}</td>
				<td>{moment(refund.created_at).format('DD-MM-YYYY')}</td>
				<td>{REFUND_REASONS.find((reason) => reason.value === refund.reason)?.label}</td>
				<td>{refund.amount}</td>
				<td>{refund.market.currency}</td>
				<td>{REFUND_STATUSES.find((status) => status.value === refund.status)?.label}</td>
				<td>
					<FlexCell>
						{refund.status === TO_DO_STATUS && <Icon onClick={() => setSelectedRefund(refund)} name='edit' />}
						{loadingFiles.includes(refund.file) ? (
							<Icon onClick={() => false} name='spinner' spin />
						) : (
							<Icon name="file-pdf" onClick={() => handleDownloadPdf(refund.file)} />
						)}
					</FlexCell>
				</td>
			</tr>
		);
	});
